export const attachmentStyles = {
  width: '74px',
  height: '74px',
  marginRight: '0px',
};

export const attachmentMobileStyles = {
  width: '87px',
  height: '87px',
  marginRight: '0px',
};

export const avatarWrapperStyles = { position: 'absolute', bottom: '-18px', left: '-18px' };
export const avatarWrapperMobileStyles = { position: 'absolute', bottom: '-32px', left: '0px' };

export const filesFormGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginBottom: '24px',
};

export const filesFormGroupMobileStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '8px',
};
